import { getInstallationId, learnerApiJson, type GetToken } from './learner-api';
import { flushProgressQueue } from './progress-queue';

const FAVORITES_KEY = 'hmonglus:web:favorites';

function localFavorites(): string[] {
  try {
    const value = JSON.parse(window.localStorage.getItem(FAVORITES_KEY) ?? '[]');
    return Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];
  } catch {
    return [];
  }
}

export async function registerWebInstallation(getToken: GetToken | null) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  await learnerApiJson(getToken, '/v1/devices/register', {
    method: 'POST',
    body: JSON.stringify({
      installation_id: getInstallationId(),
      expo_push_token: null,
      platform: 'web',
      app_version: import.meta.env.VITE_RELEASE || 'web-dev',
      locale: navigator.language,
      timezone,
      device_model: navigator.userAgent.slice(0, 128),
    }),
  });
}

export async function syncLearnerAccount(getToken: GetToken) {
  await registerWebInstallation(getToken);
  const server = await learnerApiJson<{ persistency_keys: string[] }>(
    getToken,
    '/v1/user/favorites',
    { auth: true },
  );
  const merged = [...new Set([...server.persistency_keys, ...localFavorites()])];
  if (merged.length !== server.persistency_keys.length) {
    await learnerApiJson(getToken, '/v1/user/favorites', {
      method: 'PUT',
      auth: true,
      body: JSON.stringify({ persistency_keys: merged }),
    });
  }
  window.localStorage.setItem(FAVORITES_KEY, JSON.stringify(merged));
  await flushProgressQueue(getToken);
}

export function getLocalFavorites() {
  return localFavorites();
}

export function setLocalFavorites(values: string[]) {
  window.localStorage.setItem(FAVORITES_KEY, JSON.stringify([...new Set(values)]));
}
